var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBackArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.761 6.248H3.052L7.029 2.27A.751.751 0 1 0 5.966 1.21L.707 6.468a.75.75 0 0 0 0 1.062l5.26 5.26a.751.751 0 0 0 1.062-1.063L3.052 7.75h11.71a.751.751 0 0 0 0-1.502"
})));
export default SvgBackArrow;